import { Button, Modal, Popover, Select, notification } from "antd";
import profileIcon from "../assests/new-images/profile_new.png";
import arrowIcon from "../assests/images/arrow.png";
import logOutIcon from "../assests/images/logOut.png";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowDown } from "react-icons/io";
import {
  accessListSelector,
  getLanguageSelector,
  loginDetailsSelector,
  modeSelector,
  profileDetailsSelector,
  profilePhotoSelector,
} from "../store/selectors/app.selector";
import { useCallback, useState } from "react";
import {
  setAppLanguage,
  setMenuOpen,
  setMode,
} from "../store/actions/app.action";
import AuthService from "../services/auth.service";
import { AiOutlineInfoCircle, AiOutlineMenu } from "react-icons/ai";
import moment from "moment";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { CONFIG } from "../environment";
import QuickSearch from "../components/search-options";
import { ReactComponent as BarChartIcon } from "../assests/images/bar-chart.svg";
import { ReactComponent as ContactPhoneicon } from "../assests/images/contact-phone.svg";

const modeLabels = {
  AA: "Auto Authorizer",
  A: "Authorizer",
  I: "Initiator",
  VR: "Verifier",
  VW: "Viewer",
};

export default function TopBanner() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileDetails = useSelector(profileDetailsSelector);
  const [visible, setVisible] = useState(false);
  const accessList = useSelector(accessListSelector);
  const mode = useSelector(modeSelector);
  const { t } = useTranslation();
  const [value, setValue] = useState(undefined);
  const profileImage = useSelector(profilePhotoSelector);
  const selectedLng = useSelector(getLanguageSelector);
  const languageOption = { en: "English", fr: "French" };

  const handleLanguage = useCallback((value) => {
    try {
      dispatch(setAppLanguage(value));
      i18n.changeLanguage(value);
    } catch (err) {}
  }, []);

  const handleSearchChange = useCallback((selected) => {
    try {
      setValue(selected);
      navigate(selected);
    } catch (error) {}
  }, []);

  const content = (
    <ul className="profile-options">
      <li onClick={() => navigate("/profile")}>
        {t("navigation.profile", {
          defaultValue: "Profile Details",
        })}
      </li>
      {/* <li onClick={() => navigate("/manage-userId")}>
        {t("navigation.manage_username", {
          defaultValue: "Manage User Name",
        })}
      </li> */}
      <li onClick={() => navigate("/change-password")}>
        {t("navigation.change_pass", {
          defaultValue: "Change Password",
        })}
      </li>
      <li onClick={() => setVisible(true)}>
        {t("navigation.logout", {
          defaultValue: "Log Out",
        })}
      </li>
    </ul>
  );

  const operationChange = useCallback((value) => {
    try {
      dispatch(setMode(value));
      navigate("/dashboard");
    } catch (error) {}
  }, []);

  return (
    <>
      <div className="d-flex header-wrapper">
        <div className="d-flex  align-items-center">
          <AiOutlineMenu
            onClick={() => dispatch(setMenuOpen(true))}
            className="d-block d-lg-none"
            size={20}
            style={{ marginRight: 30 }}
          />
          <span
            style={{
              color: "#252C32",
              fontWeight: "600",
              fontSize: "15.8px",
            }}
            className="d-none d-lg-block"
          >
            {profileDetails["retail"] === true
              ? t("pages.login.title", {
                defaultValue: "INTERNET BANKING",
              })
              : t("pages.login.title_corp", {
                  defaultValue: "CORPORATE BANKING",
                })}
          </span>
        </div>

        <div className="topbanner-menu d-flex justify-content-between">
          <QuickSearch />
          {/* <div style={{ margin: "0 30px" }} className="d-none d-lg-block">
            <Select
              showSearch
              placeholder={t("pages.dashboard.quick_search", {
                defaultValue: "Quick Search",
              })}
              optionFilterProp="children"
              style={{ width: 250, marginRight: 50 }}
              value={value}
              onChange={handleSearchChange}
            >
              {searchOptions.map((option, idx) => (
                <Select.Option key={idx} value={option.pathName}>
                  {option.menuName}
                </Select.Option>
              ))}
            </Select>
          </div> */}
          <ul className="d-none d-lg-block">
            <li onClick={() => navigate("/myActivity")}>
              <BarChartIcon height={17}  className="pe-2" style={{marginTop: "-3px"}}/>
              {t("navigation.my_activity", {
                defaultValue: "My Activity",
              })}
            </li>
            <li onClick={() => navigate("/help")}>
              <ContactPhoneicon height={16} className="pe-2" style={{marginTop: "-3px"}}/>
              {t("navigation.contact", {
                defaultValue: "Contact Us",
              })}
            </li>
          </ul>

          {Object.keys(accessList).length > 1 && (
            <div className="d-block">
              <Select
                placeholder="Mode"
                optionFilterProp="children"
                style={{ width: 150, marginLeft: 50 }}
                value={mode}
                onChange={operationChange}
              >
                {Object.keys(accessList).map((option, idx) => (
                  <Select.Option key={idx} value={option}>
                    {modeLabels[option]}
                  </Select.Option>
                ))}
              </Select>
            </div>
          )}
          {CONFIG.LANGUAGE_SELECTION && CONFIG.LANGUAGE_LIST?.length > 1 && (
            <div className="ms-3">
              <Select
                placeholder={t("pages.landing.choose_language", {
                  defaultValue: "Choose Language",
                })}
                style={{ width: 110 }}
                value={selectedLng}
                onChange={handleLanguage}
              >
                {CONFIG.LANGUAGE_LIST.map((option, index) => (
                  <Select.Option value={option} key={index}>
                    {languageOption[option]?.toLocaleUpperCase()}
                  </Select.Option>
                ))}
              </Select>
            </div>
          )}
         <Popover placement="bottom" content={content} trigger="hover">
          <div
            className="profile-sec d-flex"
            style={{
              margin: "0px 30px",
              padding: "5px 8px",
           
              marginRight: 15,
            }}
          >
            <img
              src={
                 profileImage?.length > 0
                   ? `data:image/png;base64,${profileImage}`
                   :
                profileIcon
              }
              alt="profile"
              height={30}
              width={30}
              style={{ alignSelf: "center" }}
              className="d-none d-lg-block"
            />
            <span className="d-block  d-lg-none">
              {/* <Popover placement="bottom" content={content} trigger="hover"> */}
                <img
                  src={
                    profileImage?.length > 0
                      ? `data:image/png;base64,${profileImage}`
                      : profileIcon
                  }
                  alt="profile"
                  height={30}
                  width={30}
                  style={{ alignSelf: "center" }}
                />
              {/* </Popover> */}
            </span>
            <div className="d-flex mt-1">
              {/* <Popover placement="bottom" content={content} trigger="hover"> */}
              <div>
                <span
                  className="d-none d-lg-block"
                  style={{
                    padding: "0 10px",
                    color: "var(--black_color)",
                    fontSize: "14px",
                    paddingRight: 5,
                    fontFamily: "ubuntuSansLight",
                  }}
                >
                  {profileDetails?.firstName} {profileDetails?.lastName}
                </span>
                {!profileDetails["retail"] && (
                  <p
                    style={{
                      color: "var(--black_color)",
                      fontSize: "12px",
                      position: "relative",
                      padding: "0 10px",
                      textAlign: "left",
                    }}
                    className="d-none d-lg-block"
                  >
                    {" "}
                    {mode === "AA"
                      ? t("common.auto_authorizer", {
                          defaultValue: "Auto Authorizer",
                        })
                      : mode === "I"
                      ? t("common.initiator", {
                          defaultValue: "Initiator",
                        })
                      : mode === "A"
                      ? t("common.authorizer", {
                          defaultValue: "Authorizer",
                        })
                      : mode === "VW"
                      ? t("common.viewer", {
                          defaultValue: "Viewer",
                        })
                      : t("common.verifier", {
                          defaultValue: "Verifier",
                        })}
                  </p>
                )}
                </div>
              {/* </Popover> */}
              <IoIosArrowDown
                className="d-none d-lg-block"
                color="#6E7C87"
                style={{ marginTop: "5px" }}
              />
            </div>
          </div>
          </Popover>
        </div>
      </div>

      <Modal
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        width={480}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center" className="mt-2">
          <AiOutlineInfoCircle size={55} className="primary-color" />
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("quickLinks.logout_desc", {
              defaultValue: "Are you sure you want to logout ?",
            })}
          </h6>

          <div align="center" className="mt-4 mb-4">
            <Button
              style={{ width: 120 }}
              type="default"
              size="large"
              onClick={() => {
                setVisible(false);
              }}
              className="secondary-btn "
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>

            <Button
              style={{ marginLeft: 20, width: 120 }}
              type="primary"
              size="large"
              onClick={async () => {
                try {
                  setVisible(false);
                  // navigate("/dashboard");
                  const response = await AuthService.postLogout();
                  dispatch({ type: "USER_LOGOUT" });
                  // await AuthService.generateKey();
                  //navigate("/login");
                  dispatch(setAppLanguage(selectedLng));
                  i18n.changeLanguage(selectedLng);
                  notification.success({
                    message: "Success",
                    description: response.data.message,
                  });
                } catch (error) {
                  setVisible(false);
                  // navigate("/dashboard");
                  dispatch({ type: "USER_LOGOUT" });
                  // await AuthService.generateKey();
                  //navigate("/login");
                  dispatch(setAppLanguage(selectedLng));
                  i18n.changeLanguage(selectedLng);

                  notification.success({
                    message: t("common.success", {
                      defaultValue: "Success",
                    }),
                    description: t("pages.login.logout_sucess_txt", {
                      defaultValue: "You have logged out successfully.",
                    }),
                  });
                }
              }}
            >
              {t("buttons.yes_btn", {
                defaultValue: "Yes",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
